import React from "react";
import { AuthProvider } from "../contexts/Auth";

import { TypeProvider } from "../contexts/Type";
import { FavoriteProvider } from "../contexts/Favorite";

const Providers: React.FC<{ children: any }> = ({ children }) => {
  return (
    <TypeProvider>
      <AuthProvider>
        <FavoriteProvider>{children}</FavoriteProvider>
      </AuthProvider>
    </TypeProvider>
  );
};

export default Providers;
